import changePageClass from './_changePageClass';

$( document ).ready(function() {
   if (window.location.href.indexOf("centralbusinessonline") > -1) {
      $(".landing-banner").css("background-image" , "url(/classpath/assets/images/business/1.jpg)");
      $(".landing-banner").css("height", "30rem");
      $(".landing-banner").css("background-position", "50%, 40%");
   }
});

export default function landingPage() {
  changePageClass('landing');
}



// WEBPACK FOOTER //
// ./src/main/js/pages/landingPage.js